import React from "react";

export default function Heading({ children, className }) {
  return <div className={`${className} text-xl font-heading mb-8`}>{children}</div>;
}
